<template>
  <div class="categories-bar">
    <ul v-if="categories" class="categories-list max-width-main-container">
      <li
        v-for="category in visibleCategories"
        :key="category.id"
        class="navegation-list"
        :style="`order:${category.order}`"
        :class="isSelected(category.slug) ? 'page-selected' : ''"
      >
        <router-link
          :to="{
            name: categoryPageName(category.slug)
          }"
        >
          {{ category.name.toUpperCase() }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { useMag } from "@/composables/useMag";
import { ref, computed } from "vue";

const { categories } = useMag();
const route = useRoute();

const isSelected = categoryName => {
  return route.name === categoryPageName(categoryName);
};

const visibleCategories = computed(() => {
  return categories.value.results?.filter(category => category.visible);
});
const location = ref(window.location.pathname);
const categoryPageName = categoryName => {
  switch (categoryName) {
    case "inicio":
      return "MagazineMainPage";
    case "trending":
      return "TrendingPage";
    case "curiosidades":
      return "CuriositiesPage";
    case "generos":
      return "GenresPage";
    case "festivales":
      return "FestivalsPage";
    case "playlists":
      return "PlaylistsPage";
    case "internacional":
      return "InternationalPage";
    case "wegowlive":
      return "WegowLivePage";
    default:
      return "NotFoundMag";
  }
};
</script>

<style scoped lang="scss">
.categories-list {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: $backgroundMagazine;
  flex-wrap: wrap;
}
@media screen and (max-width: 1000px) {
  .categories-list {
    padding: 0;
  }
}
@media screen and (max-width: $screen-md) {
  .categories-list {
    padding: 0;
  }
  .categories-bar {
    display: none;
  }
}
.categories-bar {
  position: sticky;
  top: 3.9rem;
  z-index: 2;
  background-color: $backgroundBlack;
  padding: 20px 0;
}
li {
  font-size: 14px;
}
li:hover {
  color: $topaz;
  cursor: pointer;
}
.page-selected {
  color: $topazsobrenegro;
}
</style>
